module.exports = __webpack_public_path__ + "img/suiyueyinji.c9a72859.webp";